import { GET_ADMINTOOLS_PAGE } from "shared/constants/ActionTypes";

const initialState = {
  currentPage: '',
};

const admintoolsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMINTOOLS_PAGE:
      return {
        ...state,
        currentPage: action.payload
    }

    default:
      return state;
  }

};

export default admintoolsReducer
